import { FormControl, ValidatorFn, Validators } from '@angular/forms';

export abstract class AttributeControlBase {
	public keyRegex: RegExp | null = null;
	public valueRegex: RegExp | null = null;

	protected abstract get control(): FormControl;

	protected applyValidators(extra: ValidatorFn[]): void {
		const base = this.control.validator ? [this.control.validator] : [];
		this.control.setValidators(Validators.compose([...base, ...extra]));
		this.control.updateValueAndValidity({ emitEvent: false });
	}

	public validateInput(event: KeyboardEvent): void {
		if (event.ctrlKey || event.metaKey || event.altKey) return;
		const k = event.key;
		if (k.length > 1) return;

		const input = event.target as HTMLInputElement | HTMLTextAreaElement | null;
		const cur = (this.control?.value ?? '').toString();
		const start = input?.selectionStart ?? cur.length;
		const end = input?.selectionEnd ?? cur.length;
		const candidate = cur.slice(0, start) + k + cur.slice(end);

		const keyOk = !this.keyRegex || this.keyRegex.test(k);
		const valOk = !this.valueRegex || this.valueRegex.test(candidate);
		if (!keyOk || !valOk) event.preventDefault();
	}

	public validatePaste(event: ClipboardEvent): void {
		const input = event.target as HTMLInputElement | HTMLTextAreaElement | null;
		if (!input) return;

		const pasted = event.clipboardData?.getData('text') ?? '';
		const cur = (this.control?.value ?? '').toString();
		const start = input.selectionStart ?? cur.length;
		const end = input.selectionEnd ?? cur.length;
		const candidate = cur.slice(0, start) + pasted + cur.slice(end);

		const valOk = !this.valueRegex || this.valueRegex.test(candidate);
		if (!valOk) event.preventDefault();
	}
}
